import * as Common from '@/tenant/common';

export class ECCommodity extends Common.ObjectBase {
  constructor(){
    super('ECCommodity'); 
  }
  public id:number;
  public ecFlag: Common.ECFlags = Common.ECFlags.None ;
  public ecCommodityCode:string = '';
  public ecCommodityName:string = '';
  public ecSkuCode1 :string = '';
  public ecSkuName1 : string = '';
  public ecSkuCode2 : string = '';
  public ecSkuName2 : string = '';
  public commodityId: number;    
  public commodity: Common.Commodity;
  public skuId: number;    
  public sku: Common.SKU;  
}

export class ECCommodityMasterQuery extends Common.LoadQuery {
  constructor(){
    super('ECCommodityMasterQuery',ECCommodity);
    this.sort = 'ecFlag';
  }
  public ecFlag :Common.ECFlags = Common.ECFlags.None;
  public ecCommodityCode :string; 
  public ecSkuCode1 :string; 
  public ecSkuCode2 :string;      
  public commodity :Common.Commodity;
  public sku :Common.SKU;
}


